/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AlertOptions } from './AlertOptions';
import {
    AlertOptionsFromJSON,
    AlertOptionsFromJSONTyped,
    AlertOptionsToJSON,
    AlertOptionsToJSONTyped,
} from './AlertOptions';

/**
 * 
 * @export
 * @interface AddEmergencyConfigRequest
 */
export interface AddEmergencyConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof AddEmergencyConfigRequest
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof AddEmergencyConfigRequest
     */
    spec_name: string;
    /**
     * 
     * @type {AlertOptions}
     * @memberof AddEmergencyConfigRequest
     */
    impact_detection: AlertOptions;
    /**
     * 
     * @type {AlertOptions}
     * @memberof AddEmergencyConfigRequest
     */
    fall_detection: AlertOptions;
    /**
     * 
     * @type {AlertOptions}
     * @memberof AddEmergencyConfigRequest
     */
    arc_flash_detection: AlertOptions;
    /**
     * 
     * @type {boolean}
     * @memberof AddEmergencyConfigRequest
     */
    should_force_apply_this_update: boolean;
}



/**
 * Check if a given object implements the AddEmergencyConfigRequest interface.
 */
export function instanceOfAddEmergencyConfigRequest(value: object): value is AddEmergencyConfigRequest {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('spec_name' in value) || value['spec_name'] === undefined) return false;
    if (!('impact_detection' in value) || value['impact_detection'] === undefined) return false;
    if (!('fall_detection' in value) || value['fall_detection'] === undefined) return false;
    if (!('arc_flash_detection' in value) || value['arc_flash_detection'] === undefined) return false;
    if (!('should_force_apply_this_update' in value) || value['should_force_apply_this_update'] === undefined) return false;
    return true;
}

export function AddEmergencyConfigRequestFromJSON(json: any): AddEmergencyConfigRequest {
    return AddEmergencyConfigRequestFromJSONTyped(json, false);
}

export function AddEmergencyConfigRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddEmergencyConfigRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'spec_name': json['spec_name'],
        'impact_detection': AlertOptionsFromJSON(json['impact_detection']),
        'fall_detection': AlertOptionsFromJSON(json['fall_detection']),
        'arc_flash_detection': AlertOptionsFromJSON(json['arc_flash_detection']),
        'should_force_apply_this_update': json['should_force_apply_this_update'],
    };
}

export function AddEmergencyConfigRequestToJSON(json: any): AddEmergencyConfigRequest {
    return AddEmergencyConfigRequestToJSONTyped(json, false);
}

export function AddEmergencyConfigRequestToJSONTyped(value?: AddEmergencyConfigRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'spec_name': value['spec_name'],
        'impact_detection': AlertOptionsToJSON(value['impact_detection']),
        'fall_detection': AlertOptionsToJSON(value['fall_detection']),
        'arc_flash_detection': AlertOptionsToJSON(value['arc_flash_detection']),
        'should_force_apply_this_update': value['should_force_apply_this_update'],
    };
}

